// One place for the axios-error wire shape (the response interceptor rejects
// with the axios error, so a query's error carries `.response.status`). Keeps
// the retry predicates and the 403 UI from each re-encoding the assumption.
export const errorStatus = (error: unknown): number | undefined =>
  (error as { response?: { status?: number } } | null)?.response?.status;

export const isForbidden = (error: unknown): boolean =>
  errorStatus(error) === 403;

// react-query `retry`: never retry a deterministic 4xx (403 forbidden, 404
// missing, …) — otherwise up to `max` attempts. Avoids burning retry+backoff
// latency on an error that will never succeed.
export const retryNon4xx =
  (max = 3) =>
  (failureCount: number, error: unknown): boolean => {
    const status = errorStatus(error);
    const isClientError = status != null && status >= 400 && status < 500;
    return !isClientError && failureCount < max;
  };
